import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { REACT_APP_API_URL } from "../env";

export const hotelApi = createApi({
  reducerPath: "hotelApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${REACT_APP_API_URL}/api` }),
  endpoints: (builder) => ({
    getHotelConfig: builder.query({
      query: ({ hotelID, checkIN, checkOUT }) => ({
        url: `checkAvailibilty/${hotelID}`,
        method: "POST",
        body: { check_in_date: checkIN, check_out_date: checkOUT },
      }),
    }),
    getBreakfastAvailability: builder.query({
      query: ({ hotelID, roomConfigID }) => ({
        url: `hotel/${hotelID}/room/${roomConfigID}/breakfast`,
        method: "GET",
      }),
    }),
    getHotels: builder.query({
      query: () => ({
        url: "hotels",
        method: "GET",
      }),
      transformResponse: (response) => response.data,
    }),
  }),
});

export const {
  useGetHotelConfigQuery,
  useGetBreakfastAvailabilityQuery,
  useGetHotelsQuery,
} = hotelApi;
